import SVG from './SVG'

export const YoutubeIconSVG = (props) => {
  return (
    <SVG
      width="25"
      height="18"
      viewBox="0 0 25 18"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.60941 0.880104C7.94386 0.693661 10.6989 0.600006 12.8 0.600006C14.9012 0.600006 17.6094 0.693661 19.9907 0.880104C22.7457 1.11424 24.1471 1.58078 24.52 4.33581C24.7064 5.59668 24.8 7.3241 24.8 9.09834C24.8 10.8726 24.7064 12.6468 24.52 13.8609C24.1471 16.6627 22.7457 17.0833 19.9907 17.3166C17.6094 17.5499 14.9012 17.5967 12.8 17.5967C10.6989 17.5967 7.94386 17.5499 5.60941 17.3166C2.85439 17.0833 1.40707 16.6627 1.03332 13.8609C0.892837 12.6468 0.800049 10.8726 0.800049 9.09834C0.800049 7.3241 0.892837 5.59668 1.03332 4.33581C1.40707 1.58078 2.85439 1.11424 5.60941 0.880104Z"
        fill="#FF0000"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.3719 5.50293L16.6286 9.09825L10.3719 12.7413V5.50293Z"
        fill="white"
      />
    </SVG>
  )
}
